import React from 'react';
import './playlist.scss';

export default class Playlist extends React.Component {

  constructor(props) {
    super(props);

this.state = {
  playlist: props.playlist || {},
  showDetails: props.showDetails || false,
  showImage: props.showImage || false,
  show: false,
  hasFocus: props.hasFocus|| false,
}

this.getArtworkUrl = this.getArtworkUrl.bind(this);
}

componentWillReceiveProps({ showDetails, playlist, showImage, hasFocus }) {
  this.setState({ showDetails, playlist, showImage, hasFocus });
}

getArtworkUrl(playlist) {
  const { showImage } = this.props;
  if (!showImage) return '';

  if (playlist && playlist.media && playlist.media.image && playlist.media.image.low) {
    return playlist.media.image.low;
  }
  return '';
}

render() {
  const { playlist } = this.state;
  return (
    <div className={this.state.showDetails ? "playlist playlist--details" : "playlist"}>
      <div className="artwork__imagecontainer" style={{height:'100%'}}>
        {this.state.showImage ? <img className={this.state.show ? this.state.showDetails ? "image" : "imageRadius" : "none"} src={this.getArtworkUrl(playlist)} onLoad={() => { this.state.show ? null : this.setState({ show: true }) }} /> : null}
      </div>
    </div>
  )
}
};